export const languages = [
    {
        label: 'English',
        shortCode: 'en',
        isoCode: 'en-US',
        countryCode: 'us',
    },
    {
        label: 'Türkçe',
        shortCode: 'tr',
        isoCode: 'tr-TR',
        countryCode: 'tr',
    },
];